import { useEffect, useRef } from "react";

/** A free camera goes back to its home view when playback jumps to other chapters. */
export function useResetHomeOnSpanJump(
  spanJump: number,
  cameraLocked: boolean,
  resetToHome: () => void,
): void {
  const jumped = useRef(spanJump);
  useEffect(() => {
    if (jumped.current === spanJump) {
      return;
    }
    jumped.current = spanJump;
    if (!cameraLocked) {
      resetToHome();
    }
  }, [spanJump, cameraLocked, resetToHome]);
}
